module.exports = __webpack_public_path__ + "img/Hongkong-5-hover.94afc679.jpg";